import React, { Fragment, useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Row,
  Table,
} from "reactstrap";
import { H5 } from "../../AbstractElements";
import LaporanFilterHeader from "./LaporanFilterHeader";
import useAxios from "../../Utils/useAxios";
import LaporanChart from "./LaporanChart";
import DataTableTitle from "../DataTableComponents/DataTableTitle";
import DataTable from "react-data-table-component";
import { formatRP } from "../../Utils/externalFunctions";
import LaporanChart2 from "./LaporanChart2";
import { filterSearch, filterSumberDana } from "../../Utils/FilterItems";

const LaporanContain = () => {
  const axiosInstance = useAxios();
  const [anggaranBulananList, setAnggaranBulananList] = useState([]);
  const [rencImp, setRencImp] = useState([]);
  const [unitKerja, setUnitKerja] = useState([]);
  const [sumberDana, setSumberDana] = useState([]);

  const [UMKList, setUMKList] = useState([]);
  const [UMOList, setUMOList] = useState([]);
  const [transaksiList, setTransaksiList] = useState([]);

  const [selectedUnitKerja, setSelectedUnitKerja] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState({
    tahun: "0",
    bulan: "0",
    level: "",
    sumber_dana: "0",
    unit_kerja: "",
    kode_akun: "",
    project_cost: "",
    nama_keg: "",
    nama_sub_keg: "",
    isAkumulasi: false,
  });

  const [filteredRencImp, setFilteredRencImp] = useState([]);

  console.log("UMK", UMKList);
  console.log("UMO", UMOList);
  console.log("Transaksi", transaksiList);
  console.log("rencImp", rencImp);
  console.log("sumberdana", sumberDana);
  console.log("filter", selectedFilter);

  let isMounted = true;
  useEffect(() => {
    getAnggaranBulanan();
    getRencImp();
    getUnitKerja();
    getSumberDana();
    getUMK();
    getUMO();
    getTransaksi();

    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    updateFilteredItems(rencImp);
  }, [rencImp, selectedFilter]);

  const getAnggaranBulanan = async () => {
    await axiosInstance.get("anggaranbuk/").then((res) => {
      if (isMounted) {
        setAnggaranBulananList(res.data);
      }
    });
  };
  const getRencImp = async () => {
    const response = await axiosInstance.get("rencanaimp/");
    if (response.status === 200 && isMounted) {
      let datas = response.data;
      datas = datas.filter((data) => Number(data.anggaran_tersisa) > 0);
      setRencImp(datas);
    }
  };
  const getUnitKerja = async () => {
    await axiosInstance.get("unitkerja/").then((res) => {
      if (isMounted) {
        setUnitKerja(res.data);
      }
    });
  };
  const getSumberDana = async () => {
    await axiosInstance.get("sumberdana/").then((res) => {
      if (isMounted) {
        setSumberDana(res.data);
      }
    });
  };
  const getUMK = async () => {
    try {
      const response = await axiosInstance.get("umk/");
      if (isMounted) {
        setUMKList(response.data);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const getUMO = async () => {
    await axiosInstance.get("umo/").then((res) => {
      if (isMounted) {
        setUMOList(res.data);
      }
    });
  };
  const getTransaksi = async () => {
    try {
      const response = await axiosInstance.get("transaksi/");
      if (isMounted) {
        setTransaksiList(response.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setSelectedFilter((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleLihatFilter = (data, unitKerjaList) => {
    setSelectedFilter((prev) => ({ ...prev, ...data }));
    setSelectedUnitKerja(unitKerjaList);
  };

  const updateFilteredItems = (items) => {
    const filteredItems = items
      .filter(filterSearch(["nm_org"], selectedFilter.unit_kerja))
      .filter(filterSumberDana("id_sumber_dana", selectedFilter.sumber_dana))
      .filter(filterTahun);

    setFilteredRencImp(filteredItems);
  };
  const filterTahun = (item) => {
    return item === "" ? item : item;
  };

  const daftarColumns = [
    {
      name: <DataTableTitle text={"DPSJ"} />,
      selector: (row) => row.nm_org,
      sortable: true,
      wrap: true,
    },
    // {
    //   name: <DataTableTitle text={"Tahun"} />,
    //   selector: (row) => {
    //     const date = new Date(row.date_created);
    //     return date.getFullYear();
    //   },
    //   sortable: true,
    // },
    // {
    //   name: <DataTableTitle text={"Bulan RIB"} />,
    //   selector: (row) => {
    //     const date = new Date(row.date_created);
    //     return date.getMonth();
    //   }, // TODO
    //   sortable: true,
    // },
    // {
    //   name: <DataTableTitle text={"Bulan RKA"} />,
    //   selector: (row) => {
    //     const date = new Date(row.date_created);
    //     return date.getMonth();
    //   }, // TODO
    //   sortable: true,
    // },
    {
      name: <DataTableTitle text={"Kegiatan"} />,
      selector: (row) => row.nm_keg + "-" + row.kd_keg,
      sortable: true,
      wrap: true,
    },
    {
      name: <DataTableTitle text={"Akun"} />,
      selector: (row) => row.nm_akun + "-" + row.kd_akun,
      sortable: true,
      wrap: true,
    },
    // {
    //   name: <DataTableTitle text={"Project Cost Kegiatan"} />,
    //   selector: (row) => row.project_cost || "0.00",
    //   sortable: true,
    //   wrap: true,
    // },
    // {
    //   name: <DataTableTitle text={"Token Sub Kegiatan"} />,
    //   selector: (row) => row.id_sub_kegiatan,
    //   sortable: true,
    //   wrap: true,
    // },
    {
      name: <DataTableTitle text={"Sebelum (Rp)"} />,
      selector: (row) => parseInt(row.anggaran),
      sortable: true,
      format: (row) => formatRP(row.anggaran),
      wrap: true,
    },
    {
      name: <DataTableTitle text={"Terpakai (Rp)"} />,
      selector: (row) => parseInt(row.anggaran - row.anggaran_tersisa),
      sortable: true,
      format: (row) => formatRP(row.anggaran - row.anggaran_tersisa),
      wrap: true,
    },
    {
      name: <DataTableTitle text={"Sesudah (Rp)"} />,
      selector: (row) => parseInt(row.anggaran_tersisa),
      sortable: true,
      format: (row) => formatRP(row.anggaran_tersisa),
      wrap: true,
    },
  ];

  return (
    <Fragment>
      <Container fluid={true} size="lg">
        <Row>
          <Col sm="12">
            <Card>
              <CardHeader>
                <H5>{"Laporan"}</H5>
                <span>Laporan Sisa Anggaran</span>
              </CardHeader>
              <CardHeader>
                <LaporanFilterHeader
                  unitKerja={unitKerja}
                  sumberDana={sumberDana}
                  selectedUnitKerja={selectedUnitKerja}
                  handleOnChange={handleOnChange}
                  handleLihatFilter={handleLihatFilter}
                />
              </CardHeader>
              <CardBody>
                <LaporanChart
                  filter={filterSearch}
                  anggaranBuk={anggaranBulananList}
                  UMKList={UMKList}
                  UMOList={UMOList}
                  transaksiList={transaksiList}
                  isAkumulasi={selectedFilter.isAkumulasi}
                />
                <LaporanChart2
                  filter={filterSearch}
                  anggaranBuk={anggaranBulananList}
                  UMKList={UMKList}
                  UMOList={UMOList}
                  transaksiList={transaksiList}
                  isAkumulasi={selectedFilter.isAkumulasi}
                />
              </CardBody>
              <CardBody>
                <DataTable
                  columns={daftarColumns}
                  data={filteredRencImp}
                  pagination
                  highlightOnHover
                />
                {/* <Table>
                  <tr>
                    <th>DPSJ</th>
                    <th>Tahun</th>
                    <th>Bulan RIB</th>
                    <th>Bulan RKA</th>
                    <th>Jenis Kegiatan</th>
                    <th>Project Cost Kegiatan</th>
                    <th>Token Sub Kegiatan</th>
                    <th>Kode Akun-Nama Akun</th>
                    <th>Sebelum</th>
                    <th>Terpakai</th>
                    <th>Sesudah</th>
                  </tr>
                  <tr>
                    <td>DIK</td>
                    <td>2014</td>
                    <td>2</td>
                    <td>2</td>
                    <td>Lorem ipsum</td>
                    <td>Lorem ipsum</td>
                    <td>Lorem ipsum</td>
                    <td>710103-Honor Pegawai Administrasi</td>
                    <td>28,502,113</td>
                    <td>28,458,400</td>
                    <td>43,713</td>
                  </tr>
                  <tr>
                    <td>DIK</td>
                    <td>2014</td>
                    <td>2</td>
                    <td>2</td>
                    <td>Lorem ipsum</td>
                    <td>Lorem ipsum</td>
                    <td>Lorem ipsum</td>
                    <td>610907-Beban Konsumsi</td>
                    <td>1,500,000</td>
                    <td>0</td>
                    <td>1,500,000</td>
                  </tr>
                  <tr>
                    <td>DIK</td>
                    <td>2014</td>
                    <td>2</td>
                    <td>2</td>
                    <td>Lorem ipsum</td>
                    <td>Lorem ipsum</td>
                    <td>Lorem ipsum</td>
                    <td>612903-Beban Barang Cetakan</td>
                    <td>1,000,000</td>
                    <td>0</td>
                    <td>1,000,000</td>
                  </tr>
                </Table> */}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default LaporanContain;
